/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("GroupController", function GroupController(
	$scope,
	$rootScope,
	$location,

	course,
	group,

	dxDialog,
	dxLocalize
) {
	"use strict";

	var locale = dxLocalize.getLanguage() ? dxLocalize.getLanguage() : "sv";

	$scope.reqs = {
		groups: false,
		courses: false,
	};

	$scope.courses = [];
	$scope.groups = [];

	group.getAll().then(function onSuccess(response) {
		$scope.reqs.groups = true;

		if (!response.groups || response.groups.constructor !== Array) {
			return;
		}

		var groups = [];

		for (var i = 0; i < response.groups.length; ++i) {
			var grp = response.groups[i];
			grp.draggable = true;
			groups.push(grp);
		}

		$scope.groups = groups.sort(alphabeticSortByTitle);
	});

	course.getAll().then(function onSuccess(response) {
		$scope.reqs.courses = true;

		if (!response.faults && response.courses && response.courses.constructor === Array) {
			$scope.courses = response.courses.sort(alphabeticSortByTitle);
		}
	});

	function alphabeticSortByTitle(a, b) {
		return a.title.localeCompare(b.title, locale);
	}

	$scope.groupsFilter = function groupsFilter(grp) {
		if (grp.isArchived) {
			return false;
		}

		if (!$scope.groupsFilterString) {
			return true;
		}

		if (grp.title.toLowerCase().indexOf($scope.groupsFilterString.toLowerCase()) === -1) {
			return false;
		}

		return true;
	};

	$scope.coursesFilter = function coursesFilter(crs) {
		if (crs.isArchived) {
			return false;
		}

		if (!$scope.coursesFilterString) {
			return true;
		}

		if (crs.title.toLowerCase().indexOf($scope.coursesFilterString.toLowerCase()) === -1) {
			return false;
		}

		return true;
	};

	$scope.showAddCoursePopup = function showAddCoursePopup() {
		var strippedScope = $rootScope.$new();
		strippedScope.addCourse = $scope.addCourse;
		return dxDialog.show({
			templateUrl: "/partials/popups/create-new-course.html",
			$scope: strippedScope,
		});
	};

	$scope.addCourse = function addCourse(crs) {
		$scope.courses.push(crs);
		return $scope.courses.sort(alphabeticSortByTitle);
	};

	$scope.showCreateClassPopup = function showCreateClassPopup() {
		var strippedScope = $rootScope.$new();
		strippedScope.finishCreateClass = $scope.finishCreateClass;
		return dxDialog.show({
			templateUrl: "/partials/popups/create-new-class.html",
			$scope: strippedScope,
		});
	};

	$scope.finishCreateClass = function finishCreateClass(id) {
		return $location.path("/class/" + id + "/edit");
	};
});
